import { BlockWrapper } from "../Preview";
import React from "react";
import { generateCss, generateContent, generateLink, generateEvent, generateStyle } from "../../functions/sortableFunctions";
const AComponent = ({ block, ...props }: any) => {

    return (
        <React.Fragment>
            {
                React.createElement(
                    props.componentsPreview ? "span" : 'a',
                    {
                        style: generateStyle({
                            props: {
                                ...props,
                                block
                            }
                        }),
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            }
                        }),
                        id: block.id,
                        ...block.data,
                        href: generateLink({
                            props: {
                                ...props,
                                block: block
                            },
                            link: block.data?.href
                        }),
                        onClick: block.events?.onClick ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onClick"
                            });
                        } : null,
                        onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onDoubleClick"
                            });
                        } : null,
                        onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onContextMenu"
                            });
                        } : null,
                        onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseOver"
                            });
                        } : null,
                        onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseLeave"
                            });
                        } : null
                    },
                    block.children ?
                        block.children.map((value: any, index: any) => {
                            return <BlockWrapper
                                {...props}
                                key={index}
                                block={value}
                            />
                        })
                        :
                        generateContent({
                            props: {
                                ...props,
                                block: block
                            },
                        })
                )
            }
        </React.Fragment>
    )
}
export default AComponent;